export function createShapesPageStructuredData(
  data,
  location,
  siteMetadata,
  breadcrumbItems,
) {
  const siteUrl = siteMetadata.siteUrl;
  return {
    "@context": "http://schema.org",
    "@type": "CollectionPage",
    url: siteUrl + location.pathname,
    name: "Shapes",
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbItems.map((item) => ({
        "@type": "ListItem",
        position: breadcrumbItems.indexOf(item) + 1,
        name: item.label,
        item: siteUrl + item.to,
      })),
    },
    mainEntity: {
      // added mainEntity for shapes
      "@type": "ItemList",
      itemListElement: data.allStrapiShape.edges.map((edge, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "3DModel",
          name: edge.node.name,
          url: siteUrl + "/shapes/" + edge.node.slug,
        },
      })),
    },
  };
}
